
require('../../static/css/reset.css');
require('../../sass/common/reset.scss');

require('../../common/layout/header/header').run('noLogin');
require('../../common/layout/footer/footer').run();

require('../../sass/common/footer_link_html.scss');




// WEBPACK FOOTER //
// ./src/js/licenses/licenses.js